import { TLCLogger } from "../logger";

export class TLCRest {
  /**
   *
   * @type {Number}
   * @private
   */
  static _guid = 0;

  /**
   *
   * @type {Object}
   * @private
   */
  static _requestHash = {};

  /**
   * if a request has asked to fire after it's waited then we wait.
   * @type {boolean}
   * @private
   */
  static _waiting = false;

  /**
   *
   * @type {number}
   * @private
   */
  static _activeConections = 0;

  /**
   *
   * @type {jQuery.Deferred}
   * @private
   */
  static _isWaitingDeferred = [];

  /**
   *
   * @enum {string}
   */
  static types = {
    GET: "GET",
    POST: "POST",
    PUT: "PUT",
    DELETE: "DELETE",
  };

  /**
   *
   * @param {string} restUrl
   * @return {string}
   */
  static getHashKeyFromUrl(restUrl) {
    restUrl = restUrl.replace(/\//g, "_");
    restUrl = restUrl.replace(/\./g, "_");
    return restUrl;
  }

  /**
   *
   * @param {string} restUrl
   * @param {number} guid
   */
  static removeRequestFromHash(restUrl, guid) {
    var requestHashKey = TLCRest.getHashKeyFromUrl(restUrl);
    if (TLCRest._requestHash[requestHashKey]) {
      var hash = TLCRest._requestHash[requestHashKey];
      for (var i = 0, len = hash.requests.length; i < len; i += 1) {
        var item = hash.requests[i];
        if (item.guid == guid) {
          hash.requests.splice(i, 1);
          TLCRest._activeConections--;
          break;
        }
      }
    }
  }

  /**
   *
   * @param {string} restUrl
   * @param {Object.<string,*>=} settings
   * @return {jQuery.jqXHR}
   */
  static restCall(restUrl, settings) {
    settings = settings || {};
    var deferred = $.Deferred();

    if (settings.waitOnOtherRequests && TLCRest._activeConections > 0) {
      TLCRest.waitForAllRequests().then(function () {
        settings.waitOnOtherRequests = false;
        TLCRest.restCall(restUrl, settings).then(function () {
          deferred.resolve();
        });
      });

      return deferred.promise();
    }

    var guid;
    //	try {

    TLCRest.flushPreviousCallsIfCancellable(restUrl, settings.flush);

    settings.dataType = settings.dataType || "json";
    settings.showLoader =
      settings.showLoader === undefined ? true : settings.showLoader;

    /**
     *
     * @param {Object.<string,*>} response
     * @param {string} responseString
     * @param {jQuery.jqXHR} xhr
     */
    const onSuccess = function (response, responseString, xhr) {
      TLCRest.removeRequestFromHash(restUrl, guid);
      if (settings.callback) {
        if (xhr.statusText != "abort") {
          settings.callback(response, responseString, xhr, ajaxOptions);
        }
      }
    };

    /**
     *
     * @param {XMLHttpRequest|ActiveXObject} XMLHttpRequest
     * @param {*} textStatus
     * @param {*} errorThrown
     */
    const onError = function (XMLHttpRequest, textStatus, errorThrown) {
      TLCRest.removeRequestFromHash(restUrl, guid);

      var exception;
      if (XMLHttpRequest.responseText) {
        console.error(XMLHttpRequest.responseText);
      }
      if (settings.error && textStatus != "abort") {
        settings.error(exception);
      }
    };

    /**
     * @param {jQuery.jqXHR} jqXHR
     * @param {string} textStatus
     */
    const onComplete = function (jqXHR, textStatus) {
      if (textStatus == "timeout") {
        if (settings.timeoutHandler) settings.timeoutHandler();
      }

      if (settings.showLoader) {
        TLCRest.hideAjaxLoader();
      }

      if (settings.complete) settings.complete(jqXHR, textStatus);
      if (settings.finallyHandler) settings.finallyHandler(jqXHR, textStatus);

      TLCRest.waitForAllRequestsCallback();
    };

    var ajaxOptions = {
      type:
        settings.type ||
        (settings.postData === undefined
          ? TLCRest.types.GET
          : TLCRest.types.POST),

      url: restUrl,

      dataType: settings.dataType,

      data:
        settings.postData === undefined
          ? ""
          : settings.dataType === "json"
          ? JSON.stringify(settings.postData)
          : settings.postData,

      contentType: settings.contentType || "application/json; charset=utf-8",
      success: onSuccess,
      error: onError,
      headers: settings.headers || {},
      async: settings.async === undefined ? true : settings.async,
      processData:
        settings.processData === undefined ? true : settings.processData,
      complete: onComplete,
    };

    if (settings.beforeSend) {
      ajaxOptions.beforeSend = settings.beforeSend;
    }

    if (ajaxOptions.type == TLCRest.types.POST) {
      ajaxOptions.url +=
        ajaxOptions.url.indexOf("?") > -1 ? "&_=" + $.now() : "?_=" + $.now();
    } else if (settings.cache !== undefined) {
      ajaxOptions.cache = settings.cache;
    }
    if (settings.timeout) {
      ajaxOptions.timeout = settings.timeout;
    }
    var xhr = $.ajax(ajaxOptions);
    xhr.then( () => {
      deferred.resolve.apply(this, arguments);
    });
    guid = TLCRest.addToRequestHash(restUrl, settings, xhr);

    if (settings.showLoader) {
      TLCRest.showAjaxLoader();
    }

    return deferred.promise();
  }

  /**
   *
   * @param {string} restUrl
   * @param {Object.<string,*>=} settings
   * @param {jQuery.jqXHR} xhr
   * @return {Number}
   */
  static addToRequestHash(restUrl, settings, xhr) {
    TLCRest._guid++;
    var requestHashKey = TLCRest.getHashKeyFromUrl(restUrl);
    if (!TLCRest._requestHash[requestHashKey]) {
      TLCRest._requestHash[requestHashKey] = { requests: [] };
    }
    var dataToPush = {
      guid: TLCRest._guid,
      cancellable: settings.cancellable || settings.cancelable || false,
      xhr: xhr,
    };
    TLCRest._requestHash[requestHashKey].requests.push(dataToPush);
    TLCRest._activeConections += 1;
    return TLCRest._guid;
  }

  /**
   *
   * @param {string} restUrl
   * @param {Boolean} flush
   */
  static flushPreviousCallsIfCancellable(restUrl, flush) {
    flush = flush === undefined ? false : flush;
    var requestHashKey = TLCRest.getHashKeyFromUrl(restUrl);
    var hash = TLCRest._requestHash[requestHashKey];
    if (hash) {
      var activeRequests = [];
      for (var i = 0; i < hash.requests.length; i += 1) {
        var request = hash.requests[i];
        if (flush || request.cancellable || request.cancelable) {
          TLCLogger.log("REST", restUrl, "CANCELLED", request.xhr.statusText);
          try {
            request.xhr.abort();
            i--;
          } catch (e) {
            TLCLogger.log("Abort Exception", request.xhr.statusText, e);
          }
        } else {
          activeRequests.push(hash.requests[i]);
        }
      }

      if (flush) {
        TLCRest._requestHash[requestHashKey].requests = [];
      } else {
        TLCRest._requestHash[requestHashKey].requests = activeRequests;
      }
    }
  }

  /**
   *
   * @param {string} restUrl
   * @param {function()=} callback
   * @param {function()=} errorCallback
   * @return {jQuery.jqXHR}
   */
  static fetchHTML(restUrl, callback, errorCallback) {
    var opts = {
      type: TLCRest.types.GET,
      dataType: "html",
      callback: callback || function () {},
      error: errorCallback || function () {},
      contentType: "text/html; charset=utf-8",
    };
    return TLCRest.restCall(restUrl, opts);
  }

  /**
   *
   * @param {string} restUrl
   * @param {Object.<string,*>=} settings
   * @return {jQuery.jqXHR}
   */
  static jsonCall(restUrl, settings) {
    return TLCRest.restCall(restUrl, settings);
  }

  /**
   *
   * @returns {jQuery.Promise|*}
   */
  static waitForAllRequests() {
    var waitingDeferred = $.Deferred();

    TLCRest._isWaitingDeferred.push(waitingDeferred);

    TLCRest._waiting = true;

    return waitingDeferred.promise();
  }

  /**
   *
   */
  static waitForAllRequestsCallback() {
    if (TLCRest._waiting) {
      if (TLCRest._activeConections == 0) {
        var deferred = TLCRest._isWaitingDeferred.splice(0, 1)[0];

        if (TLCRest._isWaitingDeferred.length == 0) {
          TLCRest._waiting = false;
        }

        deferred.resolve();
      }
    }
  }

  /**
   *
   * @param {string} restUrl
   * @param {Object.<string,*>=} settings
   * @return {jQuery.jqXHR}
   */
  static get(restUrl, settings) {
    settings = $(settings, {
      contentType: "application/x-www-form-urlencoded; charset=UTF-8",
      dataType: "text",
      type: TLCRest.types.GET,
    });
    return TLCRest.restCall(restUrl, settings);
  }

  /**
   *
   * @param {string} restUrl
   * @param {Object.<string,*>=} settings
   * @return {jQuery.jqXHR}
   */
  static post(restUrl, settings) {
    settings = $.extend(settings, {
      contentType: "application/x-www-form-urlencoded; charset=UTF-8",
      dataType: "text",
    });
    return TLCRest.restCall(restUrl, settings);
  }

  /**
   *
   * @param {string} restUrl
   * @param {Object.<string,*>=} settings
   * @return {jQuery.jqXHR}
   */
  static put(restUrl, settings) {
    settings = $.extend(settings, {
      contentType: "application/x-www-form-urlencoded; charset=UTF-8",
      dataType: "text",
    });
    settings.type = TLCRest.types.PUT;
    return TLCRest.restCall(restUrl, settings);
  }

  /**
   *
   * @param {string} restUrl
   * @param {Object.<string,*>=} settings
   * @return {jQuery.jqXHR}
   */
  static _delete(restUrl, settings) {
    settings = $.extend(settings, {
      contentType: "application/x-www-form-urlencoded; charset=UTF-8",
      dataType: "text",
    });
    settings.type = TLCRest.types.DELETE;
    return TLCRest.restCall(restUrl, settings);
  }

  static init() {
    const spinnerElement = $("<div></div>");
    spinnerElement
      .css({
        position: "fixed",
        top: "10px",
        right: "10px",
        "font-size": "20px",
        height: "20px",
        width: "20px",
        "z-index": "9999",
      })
      .appendTo("body");
    TLCRest.spinnerElement = spinnerElement;
  }

  static spinnerElement = null;

  static showAjaxLoader = function () {
    TLCRest.spinnerElement.spin("small");
  };

  static hideAjaxLoader = function () {
    TLCRest.spinnerElement.spin(false);
  };
}

// TODO convert to a constructor instead?
TLCRest.init();
